<template>
  <div class="text-left">
    <div class="d-flex">
      <div class=" mr-3">
        <div class="caption blue-grey--text text--darken-1  mb-1">
          {{ $t('common.roles.owner') }}
        </div>
        <ChipAvatar small :account="rev.owner" />
      </div>
      <div class="text-left">
        <div class="caption blue-grey--text text--darken-1  mb-1">
          {{ $t('common.roles.coach_one') }}
        </div>
        <ChipAvatar v-if="rev.coach" small :account="rev.coach" />
        <p v-else class="ma-0 pa-0 blue-grey--text text--darken-1">-</p>
      </div>
    </div>
    <div class="mt-3">
      <div class="caption blue-grey--text text--darken-1  mb-1">
        {{ $t('common.roles.team') }}
      </div>
      <div v-if="rev.collaborators" class="d-flex flex-wrap">
        <div
          v-for="collaborator in rev.collaborators"
          class="mb-2 mr-2"
          :key="collaborator.id"
        >
          <ChipAvatar small :account="collaborator" />
        </div>
      </div>
      <p v-else class="ma-0 pa-0 blue-grey--text text--darken-1">-</p>
    </div>
    <div class="d-flex mt-2">
      <div class="mr-4">
        <div class="caption blue-grey--text text--darken-1  mb-1">
          {{ $t('common.priority') }}
        </div>
        <Priority v-if="rev.priority" :priority="rev.priority" class="mt-1" />
        <p v-else class="ma-0 pa-0 blue-grey--text text--darken-1">-</p>
      </div>
      <div>
        <div class="caption blue-grey--text text--darken-1  mb-1">
          {{ $t('common.due_date') }}
        </div>
        <v-chip v-if="rev.dueDate" outlined small>
          <v-icon small left color="grey">
            mdi-calendar-outline
          </v-icon>
          {{ formatDate(rev.dueDate, 'MMM D, YY') }}
        </v-chip>
        <p v-else class="ma-0 pa-0 blue-grey--text text--darken-1">-</p>
      </div>
    </div>
    <div>
      <div class="caption blue-grey--text text--darken-1 mb-1">
        {{ $t('common.problem') }}
      </div>
      <div v-if="revProblem" class="body-1 blue-grey--text text--darken-3">
        {{ revProblem }}
      </div>
      <p v-else class="ma-0 pa-0 blue-grey--text text--darken-1">-</p>
    </div>
    <div class="mt-4">
      <div class="caption blue-grey--text text--darken-1  mb-1">
        {{ $t('common.solution') }}
      </div>
      <div v-if="revSolution" class="body-1 blue-grey--text text--darken-3">
        {{ revSolution }}
      </div>
      <p v-else class="ma-0 pa-0 blue-grey--text text--darken-1">-</p>
    </div>
    <div class="mt-4">
      <div class="caption blue-grey--text text--darken-1 mb-1">
        {{ $t('common.category_other') }}
      </div>
      <ChipList outlined :limit="5" :items="categories" />
    </div>
    <div class="mt-4">
      <div class="caption blue-grey--text text--darken-1 mb-1">
        {{ $t('common.tag_other') }}
      </div>
      <ChipList outlined :limit="5" :items="tags" />
    </div>
    <div class="mt-4">
      <div class="caption blue-grey--text text--darken-1 mb-1">
        {{ $t('common.site_one') }}
      </div>
      <div v-if="rev.site" class="body-2 blue-grey--text text--darken-3">
        {{ rev.site.name }}
      </div>
      <p v-else class="ma-0 pa-0 blue-grey--text text--darken-1">-</p>
    </div>
    <div class="mt-4">
      <div class="caption blue-grey--text text--darken-1 mb-1">
        {{ $t('common.creation_date') }}
      </div>
      <div class="body-2 blue-grey--text text--darken-3">
        {{ formatDate(rev.createdAt, 'MMM D, YY') }}
      </div>
    </div>
    <div class="mt-4">
      <div class="caption blue-grey--text text--darken-1 mb-1">
        {{ $t('common.evidence') }}
      </div>
      <MediaContainerThumbnailImage
        v-if="rev.image"
        readOnly
        :image="rev.image"
      />
      <p v-else class="ma-0 pa-0 blue-grey--text text--darken-1">-</p>
    </div>
  </div>
</template>

<script>
import { utils } from 'frontend-js-shared'

import ChipAvatar from '@/components/ChipAvatar.vue'
import Priority from '@/components/Priority.vue'
import ChipList from '@/components/ChipList.vue'
import MediaContainerThumbnailImage from '@/components/MediaContainer/ThumbnailImage.vue'

export default {
  name: 'RevContent',

  components: {
    ChipAvatar,
    Priority,
    ChipList,
    MediaContainerThumbnailImage,
  },

  props: {
    rev: { type: Object, required: true },
  },

  computed: {
    revProblem() {
      return (
        this.rev?.beforePhase?.situation ??
        this.rev?.relate?.problem ??
        this.rev?.problemAnalysis?.problem
      )
    },

    revSolution() {
      return (
        this.rev?.afterPhase?.solution ??
        this.rev?.expand?.solution ??
        this.rev?.solutionDescription
      )
    },

    tags() {
      return this.rev?.tags?.map(tag => tag.name) ?? []
    },

    categories() {
      return (
        this.rev?.categories?.map(category =>
          this.$t(`common.categories.${category}`)
        ) ?? []
      )
    },
  },

  methods: {
    formatDate(date, format) {
      return utils.dates.formatDate(date, format)
    },
  },
}
</script>
